import { useDispatch, useSelector } from 'react-redux'
import { AppointmentCardInterface } from '../../../Interfaces/AppointmentCardInterface'
import { GenderEnum } from '../../../enums/GenderEnum'
import { Button, Icon } from '../../Elements'
import Avatar from '../ImageAvatars/Avatar'
import { Link, useNavigate } from 'react-router-dom'
import { RaytebRequests } from '../../../_services'
import useFetch from '../../../_services/fetch'
import { addOrUpdatePrescription } from '../../../storeManager/Reducers/prescriptionSlice'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import { PrescriptionViewModel } from '../../../models/ViewModels/PrescriptionViewModel'
import LoadingFit from '../Loading/LoadingFit'
import { PatientRecordViewModel } from '../../../models/ViewModels/PaitentRecordViewModel'
import useOpenInNewTab from '../../../_services/useOpenInNewTab'
import { QueueStateEnum } from '../../../enums/QueueStateEnum'
import { ShiftResource } from '../../../resource/shiftResource'
import { PartialDeserveViewModel } from '../../../models/ViewModels/PartialDeserveViewMode'

const AppointmentCard = ({
  patient,
  appointment,
  isLoadingQueue,
  onCall,
  isCalled,
  isCalledAgain,
  isAbsent,
  isEnableQueue,
  setStartMeeting,
  patientNotRegister
}: {
  patient: string
  appointment: AppointmentCardInterface
  onCall?: () => void
  isLoadingQueue?: boolean
  isCalled?: boolean
  isAbsent?: boolean
  isCalledAgain?: boolean
  isEnableQueue: boolean
  setStartMeeting: () => void
  patientNotRegister: (data: PartialDeserveViewModel) => void
}) => {
  const navigation = useNavigate()
  const openInNewTab = useOpenInNewTab()
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const dispatch = useDispatch()
  const { isLoading, reFetch } = useFetch<PrescriptionViewModel, Object>({
    request: RaytebRequests.Prescription_Get_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(data) {
      dispatch(addOrUpdatePrescription(data))
      if (center.hasRecord) navigation('/prescription/record')
      else navigation('/prescription/newPrescription')
    },
    onStatusCode201(data) {
      patientNotRegister(data)
    },
  })
  const queue = useSelector<ReducerType, QueueViewModel>(
    (state) => state.reducerQueue
  )
  const print = useFetch<
    unknown,
    unknown,
    {
      ticketId: string
    }
  >({
    request: RaytebRequests.Prescription_Print_GET(user.token!),
    onSuccess(data) { },
  })

  const isCurrentQueue =
    queue.ticketId === appointment.ticketId && isEnableQueue
  function isToday(date: Date) {
    const today = new Date()
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    )
  }
  return (
    <>
      <div
        className={`${appointment.isDisable
          ? ' opacity-60 before:absolute before:w-full before:h-full before:z-10  bg-white'
          : ''
          } flex flex-col bg-none p-1 relative shadow-inner ${isCurrentQueue
            ? 'border-2 border-primaryLight rounded-xl scale-[103%]'
            : ''
          } transition-all duration-75 ${(isCalled && isEnableQueue) || appointment.isVisit ? 'bg-primary/20' : 'bg-white'
          } ${isCalledAgain && isEnableQueue ? '!bg-disable' : ''}
        ${isAbsent && isEnableQueue ? '!bg-dangerLight/50' : ''}`}
      >
        <LoadingFit isLoading={isLoading} />
        <div className='grid grid-cols-12 items-start px-2 py-1 min-h-[133px]'>
          <div className='col-span-2'>
            <Avatar url={appointment.imageUrl} className='!w-12 !h-12' />
          </div>
          <div className='flex flex-col justify-center items-start gap-1 col-span-7 pr-1  py-2'>
            <h2 className='text-primaryDark'>{`${appointment.firstName} ${appointment.lastName}`}</h2>
            <p className='text-xs text-primaryLight font-bold flex gap-3 '>
              <span>{appointment.code?.toPersian()}</span>
              <span>
                {appointment.gender ? GenderEnum[appointment.gender] : 'مامشخص'}
              </span>
              <span>{appointment.age}</span>
            </p>
            <div className='flex gap-3 text-xs text-primaryLight'>
              <span>{appointment.ticketTime}</span>
              <span> نوبت : {appointment.ticketNo}</span>
              <span> شیقت : {ShiftResource[appointment.shift]}</span>
            </div>
            {appointment.trackingCode ? (
              <span className='text-xs  text-primaryLight'>
                کد پیگیری : {appointment.trackingCode.toPersian()}
              </span>
            ) : (
              ''
            )}
            <span className='text-xs text-primaryLight'>
              {isEnableQueue && appointment.queueState
                ? `صف : ${isCurrentQueue && !isCalledAgain
                  ? 'فراخوان شده'
                  : isCalledAgain
                    ? 'فراخوان مجدد'
                    : QueueStateEnum[appointment.queueState]
                } `
                : ''}
            </span>
            <span className='text-xs text-primaryLight'>
              {appointment.hasAnyItems
                ? ' تاریخچه معاینه قبلی دارد'
                : ' تاریخچه معاینه قبلی ندارد'}
            </span>
          </div>
          <div className='col-span-3 flex flex-col justify-between items-end h-full py-2'>
            <div className='flex justify-end items-center gap-2'>
              {isEnableQueue && appointment.queueState ? (
                <span className='flex justify-end items-center gap-2'>
                  <div className="inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-primary bg-red-500 border-2 border-primary rounded-full">{appointment.doctorQueueNo}</div>
                  <Button className='!bg-inherit border-0 !p-0 !justify-end'>
                    <Icon
                      onClick={() => onCall?.()}
                      icon='rayteb-bell-o'
                      className={`!text-3xl text-primary`}
                    />

                  </Button>
                </span>

              ) : appointment.isCounseling ? (
                <>
                  {appointment.appointmentType === 'IsVideoChat' ?
                    <Icon
                      icon='rayteb-video-camera'
                      className='!text-2xl text-danger'
                      onClick={() => {
                        setStartMeeting()
                      }}
                    /> : null}
                  {appointment.appointmentType !== 'HasNeedRequest' ? <Link to={`/TicketRequest?ticketId=${appointment.ticketId}&date=${appointment.visitDate}`} target='_blank'>
                    <Icon
                      icon='rayteb-chat'
                      className='!text-2xl text-secondary'
                    />
                  </Link> : null}

                </>
              ) : (
                ''
              )}
            </div>
            <div className='flex flex-col gap-3'>
              {appointment.hasAnyItems ? <Link
                to={`${window.env['APP_Domain']}/api/DoctorProfile/Patient/GetAllProfiles?doctorCode=${user.userData?.code}&centerId=${center.id}&patientCode=${appointment.code}`}
                className='!text-primary !bg-none text-center !border-0 !text-[11px] hover:!border-b 
                hover:shadow-inner
            !font-bold  !w-full '
                target='_blank'
              >
                چاپ کل پرونده
              </Link> : ''}
              <Link
                to={''}
                className='!text-secondaryLight !bg-none text-center !border-0 !text-[11px] 
            !font-bold  !w-full '
                onClick={() => appointment.showDeserveModal?.(appointment)}
              >
                مشاهده/ویرایش
              </Link>
            </div>
          </div>
        </div>
        <div className='flex py-2 justify-start items-center'>
          {/*isToday(new Date(appointment.visitDate!)) &&*/ (center.hasPrescription || center.hasRecord) ? <Button
            className='bg-none border-0 !bg-inherit gap-2 !w-full !p-0'
            onClick={() => {
              reFetch({
                code: appointment.code,
                ticketId: appointment.ticketId,
              })
            }}
          >
            <Icon
              icon='rayteb-prescription'
              className={`text-xl 
            ${isCalledAgain || isCalled ? 'text-pr' : 'text-disable'}`}
            />
            <span className='text-xs text-primary '>تجویز کنید</span>
          </Button> : <></>}
          {appointment.hasPrescription === true || appointment.hasRecord === true ? <Button
            className={`bg-none border-0 !bg-inherit gap-2 !w-full !p-0 `}
            onClick={() => {
              window.open(
                `${window.env['APP_Domain']}/api/DoctorProfile/Patient/PrintPatientProfileWithPrescription?centerId=${center.id}&doctorCode=${user.userData?.code}&patientCode=${appointment.code}&insertDate=${appointment.visitDate}`
              )
            }}
          >
            <Icon
              icon='rayteb-record'
              className={`text-xl 
            ${isCalledAgain || isCalled ? 'text-primary' : 'text-disable'}`}
            />
            <span className='text-xs text-primary '>چاپ پرونده</span>
          </Button> : <></>}
          {/* <Button className='bg-none border-0 !bg-inherit gap-2 !w-full !p-0'>
            <Icon icon='rayteb-printer' className='text-xl text-disable' />
            <span className='text-xs text-primary '>چاپ پرونده</span>
          </Button> */}
          {appointment.isSend && appointment.hasPrescription === true ? (
            <Button
              className='bg-none border-0 !bg-inherit gap-2 !w-full !p-0'
              onClick={() => {
                window.open(
                  `${window.env['APP_Domain']}/api/DoctorProfile/Prescription/Print?ticketId=${appointment.ticketId}`
                )
              }}
            >
              <Icon
                icon='rayteb-printer'
                className={`text-xl
              ${isCalledAgain || isCalled ? 'text-primary' : 'text-disable'}`}
              />
              <span className='text-xs text-primary '>چاپ نسخه</span>
            </Button>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  )
}

export default AppointmentCard
